import globalConsent from '../ads/gdpr/globalConsent';
import { setUpLogger } from '../log/logger';
import { getParametersFromUrl } from './urlUtils';

export default function checkDebug(config) {
  let parameters = {};
  try {
    // eslint-disable-next-line no-undef
    parameters = getParametersFromUrl(window.top.location.search);
  } catch (error) {
    // eslint-disable-next-line no-undef
    parameters = getParametersFromUrl(window.location.search);
  }

  globalConsent.debug = parameters?.jstappxdebug || config.debug;
  globalConsent.test = parameters?.jstappxtest || config.test;
  globalConsent.testDisplay = parameters?.jstappxtestdisplay || config.testDisplay;

  globalConsent.player_load_id = `${parseInt(Math.random() * 10000, 10)}${Date.now()
    .toString()
    .substr(-4)}${parseInt(Math.random() * 10000000000, 10)}`;

  setUpLogger({
    debug: globalConsent.debug,
  });
}
